import React from "react";
import "../../App.css";
import  "./FormSection.css";

export default function FormSection({children, className}){

	return <section className={className}>{ children}</section>
}
